'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _typeof = require('@babel/runtime/helpers/typeof');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var PropTypes = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty__default['default'](target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var JotFormEmbed$1 = function JotFormEmbed(_ref) {
  var formURL = _ref.formURL,
      autoResize = _ref.autoResize,
      autoFocus = _ref.autoFocus,
      _ref$heightOffset = _ref.heightOffset,
      heightOffset = _ref$heightOffset === void 0 ? 15 : _ref$heightOffset,
      _ref$initialHeight = _ref.initialHeight,
      initialHeight = _ref$initialHeight === void 0 ? 540 : _ref$initialHeight,
      onSubmit = _ref.onSubmit,
      formID = _ref.formID,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      rest = _objectWithoutProperties__default['default'](_ref, ["formURL", "autoResize", "autoFocus", "heightOffset", "initialHeight", "onSubmit", "formID", "style"]);

  var iframeRef = React__default['default'].useRef();

  var _React$useState = React__default['default'].useState({
    height: initialHeight,
    overflow: 'hidden',
    border: 0,
    width: '100%'
  }),
      _React$useState2 = _slicedToArray__default['default'](_React$useState, 2),
      componentStyles = _React$useState2[0],
      setComponentStyles = _React$useState2[1];

  React.useEffect(function () {
    var handleMessages = function handleMessages(content) {
      if (!content) {
        return;
      } // Check if submission is completed.


      if (_typeof__default['default'](content.data) === 'object' && content.data.action === 'submission-completed') {
        onSubmit();
        return;
      } // From now on we only handle style related messages


      if (typeof content.data !== 'string') {
        return;
      }

      var _content$data$split = content.data.split(':'),
          _content$data$split2 = _slicedToArray__default['default'](_content$data$split, 3),
          method = _content$data$split2[0],
          value = _content$data$split2[1],
          targetForm = _content$data$split2[2]; // eslint-disable-next-line eqeqeq


      if (formID && targetForm && targetForm != formID) {
        // If you want to use multiple form via embed you need to use formID
        return;
      }

      switch (true) {
        case method === 'scrollIntoView' && autoFocus:
          if (typeof iframeRef.current.scrollIntoView === 'function') {
            iframeRef.current.scrollIntoView();
          }

          break;

        case method === 'setHeight' && autoResize:
          setComponentStyles(_objectSpread(_objectSpread({}, componentStyles), {}, {
            height: parseInt(value, 10) + heightOffset
          }));
          break;

        case method === 'setMinHeight' && autoResize:
          setComponentStyles(_objectSpread(_objectSpread({}, componentStyles), {}, {
            minHeight: parseInt(value, 10) + heightOffset
          }));
          break;

        case method === 'reloadPage':
          iframeRef.current.reload();
          break;
      }
    };

    if (window.addEventListener) {
      window.addEventListener('message', handleMessages, true); // Capture
    } else if (window.attachEvent) {
      window.attachEvent('onmessage', handleMessages);
    }

    return function () {
      if (window.removeEventListener) {
        window.removeEventListener('message', handleMessages, true);
      }
    };
  }, []);
  return /*#__PURE__*/React__default['default'].createElement("iframe", _extends__default['default']({
    ref: iframeRef,
    src: formURL,
    title: "JotForm Form",
    style: _objectSpread(_objectSpread({}, componentStyles), style),
    allowTransparency: "true",
    allowFullScreen: "true",
    allow: "geolocation; microphone; camera",
    frameBorder: "0",
    scrolling: "no"
  }, rest));
};

var noop = function noop() {};

JotFormEmbed$1.propTypes = {
  formURL: PropTypes__default['default'].string.isRequired,
  formID: PropTypes__default['default'].oneOfType(PropTypes__default['default'].number, PropTypes__default['default'].bool),
  autoResize: PropTypes__default['default'].bool,
  autoFocus: PropTypes__default['default'].bool,
  heightOffset: PropTypes__default['default'].number,
  initialHeight: PropTypes__default['default'].number,
  onSubmit: PropTypes__default['default'].func,
  style: PropTypes__default['default'].shape({})
};
JotFormEmbed$1.defaultProps = {
  autoResize: true,
  formID: false,
  autoFocus: true,
  heightOffset: 15,
  initialHeight: 540,
  onSubmit: noop,
  style: {}
};

var JotFormEmbed = JotFormEmbed$1;

exports.JotFormEmbed = JotFormEmbed;
exports.default = JotFormEmbed$1;
